import React, { useRef, useState } from 'react';

import styles from './Main.module.scss';

import loader from '../../../../Assets/Icons/Spinner.svg'
import { useEffect } from 'react';
import { initialSummaryDetails } from '../../../../Redux/Reducers/initialValues';
import { useSelector } from 'react-redux';
import { getFromApi } from '../../../../API/generalCalls';
import { Link } from 'react-router-dom';
import journal from '../../../../Assets/BookCovers/journal.png'
import story from '../../../../Assets/BookCovers/story.png'

const Main = ({ code, getBookDetails, showLoader, showError, setStage, setBookDetails, setSummaryDetails, setUserDetails }) => {
  
  const userDetails = useSelector(state => state.storeData.userDetails);
  const inputRef = useRef()

  const handleSubmit = () => {
      if(inputRef.current.value.length===5){
        getBookDetails(inputRef.current.value)
      }
  }

  const getUserData = async () => {
    const details = await getFromApi('store/points_details')
    if(details)setUserDetails({
      ...details,
      teacher:true
    })
  }
  
  
  useEffect(()=>{
    if(!userDetails||!userDetails.fullName){
      getUserData()
    }
    setSummaryDetails( initialSummaryDetails )
    setStage(0)
  },[])

  return (
    <div className={styles.container}>
      
    { showLoader &&

      <div className={styles.loadingOverlay}>
        <img src={loader} alt="loader" />
        <p>Retreiving book details...</p>
      </div>
      // : null
    }

      <div className={styles.topBanner}>
        <div className={styles.content}>
          <h1>Purchase your child's writing today</h1>
          <div className={styles.input}>
            <input ref={inputRef} autoFocus maxLength={5} type="text" name="codeInput" id="codeInput" defaultValue={code?code:null}  placeholder={"Book access code E.g: GHJB"}  onInput={(e)=>e.target.value=e.target.value.toUpperCase()}/>
            {/* <div onClick={handleSubmit} className={styles.purchaseBtn}>Purchase now</div> */}
            {showError && <div className={styles.error}>No such code found, please check input</div>}
          </div>
        </div>

        <div className={styles.books}>
            <img className={styles.bookCover} src={journal} alt="journal cover" />
            <img className={styles.bookCover} src={story} alt="story cover" />
        </div>
      </div>
{/* 
      <div className={styles.bottom}>


        <Link to={'/store/products'} onClick={()=>setStage(1)} className={`${styles.bubble} ${styles.dark}`}>
          <h3>Check out our store</h3>
          <p>And get your child their favorite and most stylin’ Escribli clothes and gear!</p>
        </Link>
        <Link className={`${styles.bubble} ${styles.light}`} to='/parents'>
            <h3>Keep in touch with your child's writing!</h3>
            <p>Register as a parent to be ”in the loop” with your child's class writing activities and to create your own activities for your child to do at home.</p>
        </Link>
      </div> */}

    </div>
  )

}

export default Main;